export const RESTRICTED_APP_ACCESS =
  "You don't have access to this application";
export const ACCOUNT_CLOSED = "Your account has been closed";
export const ACCOUNT_SUSPENDED = "Your account has been suspended";
